/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientReceiptUrlApiResponse } from '../models/ClientReceiptUrlApiResponse';
import type { ClientTransactionDetailApiResponse } from '../models/ClientTransactionDetailApiResponse';
import type { FetchClientTransactionsApiResponse } from '../models/FetchClientTransactionsApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientAppTransactionsService {
    /**
     * Get client transaction history
     * Returns filtered, paginated list of transactions for the authenticated client. Supports filtering by status and time period.
     * @param statuses Filter by one or more payment statuses
     * @param dateFrom Filter transactions on/after this UTC timestamp.
     * @param dateTo Filter transactions before this UTC timestamp (exclusive).
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns FetchClientTransactionsApiResponse Transactions fetched
     * @throws ApiError
     */
    public static clientTransactionsControllerFetchTransactionsV1(
        statuses?: Array<'pending' | 'completed' | 'failed' | 'refunded'>,
        dateFrom?: string,
        dateTo?: string,
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<FetchClientTransactionsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/transactions',
            query: {
                'statuses': statuses,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Get transaction detail
     * Returns full details for a single transaction belonging to the authenticated client.
     * @param id Transaction UUID
     * @returns ClientTransactionDetailApiResponse Transaction detail fetched
     * @throws ApiError
     */
    public static clientTransactionsControllerGetTransactionDetailV1(
        id: string,
    ): CancelablePromise<ClientTransactionDetailApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/transactions/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Transaction not found`,
            },
        });
    }
    /**
     * Get Stripe receipt URL for a transaction
     * Returns a Stripe-hosted receipt URL for the specified transaction. Only available for completed or refunded transactions.
     * @param id Transaction UUID
     * @returns ClientReceiptUrlApiResponse Receipt URL fetched
     * @throws ApiError
     */
    public static clientTransactionsControllerGetReceiptUrlV1(
        id: string,
    ): CancelablePromise<ClientReceiptUrlApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/transactions/{id}/receipt',
            path: {
                'id': id,
            },
            errors: {
                400: `Receipt not available for this transaction status`,
                404: `Transaction not found`,
            },
        });
    }
}
